/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {syncContacts} from '../api'

export const useMutationSyncContacts = createReactQueryMutationHook('syncContacts', syncContacts)
